<template>
  <section>
    <PageName title="Внешние пассажиры"/>
  
    <!-- <vue-table-dynamic
      v-show="!passengersLoading"
      id="table"
      @select="selectHandler"
      @select-all="allSelectHandler"
      @row-click="openPassenger"
      :params="params"
    ></vue-table-dynamic> -->

    <div class="header__page">
      <VInput
        v-model="search"
        @enter="searchPassangers"
        icon="search"
        width="469px"
        placeholder="Поиск по пользователям"
      />

      <div class="buttons">
        <Button
          v-for="(button, i) in this.buttons"
          v-show="!button.hide"
          :key="'head' + i"
          :text="button.text"
          :icon="button.icon"
          width="100%"
          :iconWidth="button.iconWidth || '15px'"
          class="buttons__item"
          @click="button.event"
        />
      </div>
    </div>

    <Preloader v-if="passengersLoading" />

    <VTable
        v-show="!passengersLoading"
        itemsType="array"
        :columns="passengersColumns"
        :items="mapedPassengers"
        :sortApi="sortPassengers"
        :selectedIndices="selectedIndices"
        @select="select"
        @row-click="openPassenger"
        selectable
        ref="table"
    />

  </section>
</template>

<script>

import { simpleDate } from "@/utils/filters/dateFilters";
// import { phone } from "@/utils/filters/formatFilters";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { deletePassengers } from "@/api/passengers";
import VTable from "@/components/Table/VTable";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import Button from "@/components/Button.vue";
import PageName from "@/components/PageName";
import Preloader from "@/components/Preloader";

export default {
  name: "Passengers",
  components: {
    PageName,
    VTable,
    VInput,
    Preloader,
    Button
  },

  data() {
    return {
      selectedPassengersIds: [],
      passengersColumns: [
        { title: "№", sort: true, value: "id" },
        { title: "Cоздан", sort: true, value: "created_at" },
        { title: "Изменен", sort: false, value: "updated_at" },
        { title: "Пол", sort: false, value: "sex" },
        { title: "День рождения", sort: false, value: "birthday" },
        { title: "Гражданство", sort: false, value: "citizenship" },
        { title: "Тип документа", sort: false, value: "document.name" },
        { title: "Номер документа", sort: false, value: "document_number" },
        { title: "Срок действия документа", sort: false, value: "document_validity" },
        { title: "Телефон", sort: false, value: "phone" },
        { title: "Фамилия", sort: false, value: "surname" },
        { title: "Имя", sort: false, value: "name" },
        { title: "Отчество", sort: false, value: "patronymic" },
        { title: "Логин", sort: false, value: "email" }, // TODO: изменить на login когда бэкенд будет обновлен
        { title: "VIP", sort: false, value: "is_vip" }
      ],
      paramsWidthSort: {
        page: 1,
        sort: '',
        search: '',
      },
      search:'',
      buttons: [
          {
            text: "Создать",
            icon: "addFile",
            event: this.create || this.callback,
          },
          {
            text: "Удалить",
            icon: "delete",
            event: this.delete || this.callback,
            iconWidth: "12px",
          },
      ],
    };
  },
  async mounted() {
    const params  = {
      page: 1,
      sort: 'id'
    }
    this.getPassengers(params)
  },
  computed: {
    ...mapState("users", ["passengers", "passengersLoading"]),
    ...mapGetters('users', ['getPassengersListPagination']),
    ...mapState("departments", ["departments"]),

    // pagination () {
    //   return this.getPassengersListPagination
    // },
  
    mapedPassengers() {
      return this.passengers?.map((pas) => {
        if (pas.department) {
          const include = this.departments?.filter(dep => dep?.id === pas.department.id)
          if (!include.length) {
            this.departments.unshift(pas.department)
            this.SET_DEPARTMENTS(this.departments)
          }
        }
        return [
          pas.id,
          pas.created_at ? simpleDate(pas.created_at) : "-",
          pas.updated_at ? simpleDate(pas.updated_at) : "-",
          pas.sex ? "Мужской" : "Женский",
          pas.birthday ? simpleDate(pas.birthday) : "-",
          pas.citizenship || "-",
          pas.document?.name || "-",
          pas.document_number || "-",
          pas.document_validity ? simpleDate(pas.document_validity) : "-",
          pas.phone ? pas.phone : "-",
          pas.surname || "-",
          pas.name || "-",
          pas.patronymic || "-",
          pas.email || "-", // TODO: изменить на pas.login когда бэкенд будет обновлен
          pas.is_vip ? "Да" : "Нет",
        ];
      });
    },
    selectedIndices: {
      get() {
        const indeces = [];

        this.passengers.forEach((passenger, i) => {
          if (this.selectedPassengersIds[passenger.id] !== undefined) {
            indeces.push(i);
          }
        });

        return indeces;
      },
      set(val) {
        const ids = [];
        for (let index = 0; index < val.length; index++) {
          const passenger = this.passengers[val[index]];
          if (passenger?.id) ids[passenger.id] = passenger;
        }
        this.selectedPassengersIds = ids;
      },
    },
  },
  methods: {
    ...mapActions("users", ["getPassengers"]),
    ...mapMutations("departments", ["SET_DEPARTMENTS"]),

    getPage (pageNum) {
      const params = {
        page: pageNum,
        sort: this.paramsWidthSort.sort,
        search: this.paramsWidthSort.search
      }
        this.$store.dispatch('users/getPassengersListPage', params)
    },

    sortPassengers(col, sort) {
      this.paramsWidthSort = {
        page: 1,
        sort: (sort ? "" : "-") + col?.value,
        search: this.paramsWidthSort.search
      }
      this.$store.dispatch('users/getPassengersListPage', this.paramsWidthSort)
    },

    select(value, index, all = null) {
      if (all !== null) {
        this.selectedIndices = all ?this.passengers.map((el, i) => i) : [];
      } else if (value) {
        this.selectedIndices = [...this.selectedIndices, index];
      } else {
        this.selectedIndices = this.selectedIndices.filter((i) => i === index);
      }
    },

    openPassenger(num) {
      this.$router.push(
        `/admin-panel/profile/passengers/${this.passengers[num - 1].id}`
      );
    },

    delete() {
      if (this.selectedPassengersIds.length) {
        const deleteCallback = async () => {
          const ids = this.selectedPassengersIds.map(({ id }) => id);
          await deletePassengers(ids)
          this.$root.alert("Пассажиры успешно удалены");
          this.getPassengers();
        };
        this.$root.confrim(
          "Вы уверены, что хотите удалить пассажиров?",
          deleteCallback,
          "Да"
        );
      }
    },

    create() {
      this.$router.push(
          `/admin-panel/save/${"passengers"}`
      );
    },

    searchPassangers() {
      this.paramsWidthSort = {
        page: 1,
        sort: this.paramsWidthSort.sort,
        search: this.search
      }
      this.$store.dispatch('users/getPassengersListPage', this.paramsWidthSort)
    }
  }
  // destroyed () {
  //   this.$store.commit('users/RESET_PASSENGERS_LIST_CURRENT_PAGE')
  // },
};
</script>

<style scoped lang="scss"></style>
